export default [
    {
        path: 'roles',
        component: () =>
            import('@/views/roles/components/RolesWrapper.vue'),
        children: [
            {
                path: "",
                name: "roles",
                component: () => import("@/views/roles/RoleSearch.vue"),
            },
            {
                path: "/roles/new",
                name: "newrole",
                component: () => import("@/views/roles/ManageRole.vue"),
            },
            {
                path: "/roles/:roleId?",
                name: "editrole",
                component: () => import("@/views/roles/ManageRole.vue"),
                props:true
            },

        ]
    }
]